import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { StorePosInfoListType } from '@kinderlabs-pos/shared-data-type';

export const getStoreSalesDeviceInfoListAsync = (rootUrl: string) => {
	return async () =>
		(await posAxiosClient.get<StorePosInfoListType[]>(`${rootUrl}/pos-bff/store/device-info/list`))
			.data;
};
